module.exports = __webpack_public_path__ + "img/amara-black-logo.0ec65872.png";